// Built-in privacy notice, terms and accessibility statement (WORKPACKAGES
// 3.1): plain default text. An organisation that hosts its own versions sets
// PRIVACY_URL / TERMS_URL / ACCESSIBILITY_URL, and the footer links there.
import { useMeta } from "../api/meta";
import { PageHeader } from "../ui/PageHeader";

export function PrivacyPage() {
  const meta = useMeta();
  return (
    <article className="signin-card">
      <PageHeader title="Privacy notice" />
      <p>
        {meta.appName} stores the project information your organisation enters: people, activities, events, experts and money. Your
        organisation decides what is kept and for how long; it is the controller of that data and {meta.appName} processes it on its
        behalf.
      </p>
      <p>All data is stored in the European Union. We do not sell data or use it for advertising.</p>
      <p>
        When your organisation imports a project, the files are read with Azure AI in the European Union to fill in the project.
        Microsoft does not use them to train models. A person checks the results before they are saved, and an administrator can
        switch this off.
      </p>
      <p>
        If you use the support assistant, your questions and the parts of {meta.appName} it looks up for you are read with Azure AI in the
        European Union. Chats are kept for 30 days and only you can see them.
      </p>
      <p>
        To see, correct or delete what is held about you, contact the organisation that invited you, or write to{" "}
        <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a>.
      </p>
    </article>
  );
}

export function TermsPage() {
  const meta = useMeta();
  return (
    <article className="signin-card">
      <PageHeader title="Terms" />
      <p>
        {meta.appName} is provided to organisations that run EU-funded projects. Each organisation is responsible for the people it
        invites and the information it enters. Use the service lawfully and keep your sign-in details to yourself.
      </p>
      <p>
        Questions: <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a>.
      </p>
    </article>
  );
}

export function AccessibilityPage() {
  const meta = useMeta();
  return (
    <article className="signin-card">
      <PageHeader title="Accessibility" />
      <p>
        {meta.appName} aims to meet WCAG 2.2 level AA. Every page works with a keyboard and a screen reader, text can be enlarged to
        200%, and colour is never the only way information is shown.
      </p>
      <p>
        If something does not work for you, write to <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a> and we will help.
      </p>
    </article>
  );
}
